import { NextPageWithAuth } from "pages/_app";
import useFirstSidebarPage from "hooks/useFirstSidebarPage";
import { useRouter } from "next/router";
import Loading from "components/loading";
import { useEffect } from "react";
import { Box } from "@mui/material";

const Home: NextPageWithAuth = () => {
  const firstValidPageRoute = useFirstSidebarPage({});

  const router = useRouter();

  useEffect(() => {
    // upon logging in - user's will be redirected here - we will identify the first valid page (they have permission for) on the main sidebar and redirect there
    router.push(firstValidPageRoute);
  }, []);

  return (
    <Box>
      <Loading />
    </Box>
  );
};

Home.auth = {
  auth: true,
};

export default Home;
